import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { difference } from "lodash";

export default function getDisabledItemsByFilters(
  items: InventoryItem[],
  filterItems: InventoryItem[],
) {
  if (items.length === filterItems.length) {
    return [];
  }
  const inventoryIds = items.map((item) => item.id);
  const filterIds = filterItems.map((item) => item.id);
  return difference(inventoryIds, filterIds);
}
